import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.min.css";
import { useState, useEffect } from "react";
import { fetchRatings } from "../slice/ratingSlice";
import { createRestaurant } from "../slice/restaurantSlice";
import { createRestaurantListItem } from "../slice/restaurantListItemsSlice";

const GooglePlace = ({ place, listSid }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [isSelected, setIsSelected] = useState(false);
  const [dateAttended, setDateAttended] = useState("");
  const [ratingId, setRatingId] = useState(-1);
  const [rating, setRating] = useState({});
  const [notes, setNotes] = useState("");
  const [isSaving, setIsSaving] = useState(false);

  const reduxRatings = useSelector((state) => state.ratings.ratings);

  useEffect(() => {
    dispatch(fetchRatings());
  }, [dispatch]);

  const handleRatingSelected = (event) => {
    const value = parseInt(event.target.value, 10);
    const selectedRating = reduxRatings.find((r) => r.value === value);
    setRatingId(value);
    setRating(selectedRating);
  };

  const handleSelect = () => {
    setIsSelected(true);
  };

  const handleSave = async (e) => {
    e.preventDefault();
    try {
      setIsSaving(true);
      const resultAction = await dispatch(
        createRestaurant({ name: place?.name, googlePlaceId: place?.googlePlaceId })
      );
      if (createRestaurant.fulfilled.match(resultAction)) {
        const restaurantSid = resultAction.payload?.sid;
        const restaurantListItem = {
          listSid,
          restaurantSid,
          dateAttended,
          rating: rating?.value,
          notes,
        };
        const itemResultAction = await dispatch(
          createRestaurantListItem(restaurantListItem)
        );
        if (createRestaurantListItem.fulfilled.match(itemResultAction)) {
          navigate(`/restaurants/${listSid}/${itemResultAction.payload?.sid}`);
        }
      }
    } finally {
      setIsSaving(false);
    }
  };

  const inputClasses =
    "w-full border border-stone-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-teal-600";

  return (
    <div
      className="card p-4 cursor-pointer hover:border-teal-600 max-w-md space-y-1"
      onClick={handleSelect}
    >
      <div className="font-medium text-stone-800">{place?.name}</div>
      <div className="text-sm text-stone-500">{place?.formattedAddress}</div>
      {place?.rating > 0 && (
        <div className="text-sm text-stone-500">
          {place?.rating} &#9733; ({place?.userRatingCount})
        </div>
      )}
      {isSelected ? (
        <div
          className="space-y-3 pt-2 border-t border-stone-200"
          onClick={(e) => e.stopPropagation()}
        >
          <div>
            <label className="block text-sm font-medium text-stone-500 mb-1">
              Date attended
            </label>
            <Flatpickr
              className={inputClasses}
              value={dateAttended}
              onChange={(selectedDates) => setDateAttended(selectedDates[0])}
              options={{ dateFormat: "Y-m-d" }}
            />
          </div>
          <select
            id="dropdown"
            value={ratingId}
            onChange={handleRatingSelected}
            className={inputClasses}
          >
            <option value="-1" disabled>
              Rating
            </option>
            {reduxRatings.map((r) => (
              <option key={r.value} value={r.value}>
                {r.description}
              </option>
            ))}
          </select>
          <textarea
            placeholder="Notes"
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            className={`${inputClasses} min-h-[80px]`}
          />
          <div className="flex justify-end">
            <button
              type="button"
              disabled={isSaving}
              onClick={handleSave}
              className="btn-primary"
            >
              {isSaving ? "Saving..." : "Save"}
            </button>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default GooglePlace;
